import { Component, OnInit, ViewChild } from '@angular/core';

import { confirm, alert } from 'devextreme/ui/dialog';
import { DxSchedulerComponent, DxContextMenuComponent, DevExtremeModule } from '../../../../node_modules/devextreme-angular';
import { ArkUnitOfWork, AuthService, AppInformationService } from '../../core/core.module';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Location } from '@angular/common';
import { SharedModule } from 'app/shared/shared.module';
import _ from 'lodash';
import moment from 'moment';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { InputDialogComponent } from 'app/shared/input-dialog/input-dialog.component';
import { OfferingScheduleDialogComponent } from '../offering-schedule-dialog/offering-schedule-dialog.component';
import { ContributionBatch, OfferingSchedule } from 'app/core/model/entity-model';

const appointmentClassName = '.dx-scheduler-appointment';

@Component({
    selector: 'app-offering-schedule',
    templateUrl: './offering-schedule.component.html',
    styleUrls: ['./offering-schedule.component.scss'],
    imports: [DevExtremeModule],
    standalone: true,
})
export class OfferingScheduleComponent implements OnInit {
    employees: any;
    currentDate = new Date();
    employee: any;
    timeCategories: any;
    schedulerData: any;
    selectedDate = new Date();
    showAsDialog = false;
    result: Subject<any> = new Subject<any>();
    processing = true;
    currentViewStart: any;
    specialAccounts: any[];
    target: string = appointmentClassName;
    gray: string = '#C0C0C0';
    blue: string = '#1c84c6';
    red: string = '#FF0000';

    onToolbarPreparing = SharedModule.onToolbarPreparing;
    @ViewChild('scheduler') scheduler: DxSchedulerComponent;
    @ViewChild('appointmentMenu') appointmentMenu: DxContextMenuComponent;
    @ViewChild('cellMenu') cellMenu: DxContextMenuComponent;

    appointmentContextMenuItems = [
        // { text: "Add New", onItemClick: (e) => this.addFlockSchedule(e) },
        { text: 'Create as New Batch', onItemClick: (e) => this.createNewBatch() },
        { text: 'Open Batch', onItemClick: (e) => this.openBatchFromAppointmentClick() },
        { text: 'Edit Scheduled Offering', onItemClick: (e) => this.editOffering() },
        { text: 'Assign to Existing Batch', onItemClick: () => this.assignToBatch() },
        { text: 'Delete Scheduled Offering', onItemClick: (e) => this.delete() },
        { text: 'Go to Today', onItemClick: () => this.showCurrentDate() },
    ];

    cellContextMenuItems = [
        { text: 'Add New Offering', onItemClick: (e) => this.addNewOffering(e) },
        { text: 'Go to Today', onItemClick: () => this.showCurrentDate() },
    ];

    contextMenuCellData: any;
    appointmentData: any;

    constructor(
        private uow: ArkUnitOfWork,
        private auth: AuthService,
        protected location: Location,
        private modalService: BsModalService,
        private appInfo: AppInformationService,
        private router: Router
    ) {}

    async ngOnInit() {
        await this.getData();
    }

    async getData() {
        this.specialAccounts = await this.uow.getAccounts();
        const scheduleData = await this.uow.offeringSchedules.all(null, 'specialAccount');

        this.schedulerData = scheduleData
            .filter((x) => {
                return !x.deleted;
            })
            .map((x: any) => {
                const startDate = x.aMOffering ? moment(x.offeringDate).startOf('day').toDate() : moment(x.offeringDate).startOf('day').add(12, 'hours').toDate();
                const endDate = x.aMOffering ? moment(x.offeringDate).startOf('day').add(12, 'hours').toDate() : moment(x.offeringDate).endOf('day').toDate();
                return {
                    id: x.id,
                    name: x.specialAccount ? x.specialAccount.name : `No Account Set`,
                    aMOffering: x.aMOffering,
                    startDate: startDate,
                    endDate: endDate,
                    color: x.batchId ? this.gray : endDate < new Date() ? this.red : this.blue,
                    // amount: x.batchId ? x.batch.batchTotalAmount : 0
                };
            });
    }

    setBackGroundColor(e) {
        e.appointmentElement.style.backgroundColor = e.appointmentData.color;
    }
    toolTip(e) {
        e.cancel = true;
    }

    onCellContextMenu(e) {
        this.contextMenuCellData = e.cellData;
    }
    onAppointmentContextMenu = (e) => {
        this.appointmentData = e.appointmentData;
    };

    onContentReady(e) {
        this.currentViewStart = moment(e.component.getStartViewDate()).format('M/DD/YYYY');
    }

    showCurrentDate() {
        this.currentDate = new Date();
    }

    onAppointmentDoubleClick = (e) => {
        e.cancel = true;
        this.addNewOffering(e);
    };

    onContextMenuItemClick = (e) => {
        e.itemData.onItemClick(e);
    };
    onAppointmentMenuItemClick = (e) => {
        // e.itemData.onItemClick = (e) => {return e};
    };

    async editOffering() {
        if (!this.appointmentData) return;
        const appointmentData = {
            appointmentData: { id: this.appointmentData.id },
        };
        this.addNewOffering(appointmentData);
    }

    async addNewOffering(e) {
        // console.log(e);
        let schedule = null;
        if (!!e && !!e.appointmentData) {
            schedule = (await this.uow.offeringSchedules.byId(e.appointmentData.id)) as OfferingSchedule;
        }
        const modalRef = this.modalService.show(OfferingScheduleDialogComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                mode: !!schedule ? null : 'new',
                offeringSchedule: schedule,
                offeringDate: this.contextMenuCellData ? moment(this.contextMenuCellData.startDate).startOf('day').toDate() : null,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
            }
            await this.getData();
            modalRef.hide();
        });
        this.processing = false;
    }

    async createNewBatch() {
        if (!this.appointmentData) return;
        const offering = (await this.uow.offeringSchedules.byId(this.appointmentData.id)) as OfferingSchedule;
        if (!!offering.batchId) {
            await alert(`There is ALREADY a batch assigned to this schedule`, `${this.appInfo.settings.church}`);
            return;
        }
        const result = await confirm(`Are you sure you want to CREATE this batch?`, `${this.appInfo.settings.church}`);
        if (!result) return;

        const batch = this.uow.contributionBatches.createEntity() as ContributionBatch;
        batch.created = new Date();
        batch.createdBy = this.auth.currentUser.userName;
        batch.date = offering.offeringDate;
        batch.specialAccountId = offering.specialAccountId;
        batch.statusId = 1;

        const bagNumber = await this.getBagNumber();
        if (!bagNumber) return;
        batch.bagNumber = bagNumber;




        let offeringName = '';
        if (!!offering.specialAccountId) {
            offeringName = (_(this.specialAccounts).find({ id: offering.specialAccountId } as any) as any).name;
        }
        const batchDateStr = moment(offering.offeringDate).format('MM/DD/YYYY');
        batch.name = `${batchDateStr} ${offering.aMOffering ? 'AM' : 'PM'} Offering - ${offeringName}`;
        offering.batchId = batch.id;
        await this.uow.commit();
        this.openBatch(batch.id);
    }

    getBagNumber(): Promise<any>  {
        const modalRef = this.modalService.show(InputDialogComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                mode: 'text',
                dialogHeader: 'GRAAFSCHAP CRC',
                dialogPrompt: 'Bag Number',
                checkNumeric: false,
                checkInteger: false,
                saveAndNewVisible: false,
                autoSaveIfNotEmpty: true,
            },
        });

        const promise = new Promise<any | null>(async (resolve, reject) => {
            modalRef.content.result.subscribe(async (result) => {
                if (result.success && !!result.value) {
                    resolve(result.value);
                }
                modalRef.hide();
                resolve(null);
            });
        });
        return promise;
    }

    async openBatchFromAppointmentClick() {
        if (!this.appointmentData) return;
        const offering = (await this.uow.offeringSchedules.byId(this.appointmentData.id)) as OfferingSchedule;
        if (!offering || !offering.batchId) {
            await alert(`There is no batch assigned to this schedule`, `${this.appInfo.settings.church.toUpperCase()} CHURCH`);
            return;
        }
        this.openBatch(offering.batchId);
    }

    async openBatch(batchId: number) {
        if (!batchId) return;
        if (batchId) this.router.navigate(['/giving/batches/' + batchId]);
    }

    async assignToBatch() {
        if (!this.appointmentData) return;
        const offering = (await this.uow.offeringSchedules.byId(this.appointmentData.id)) as OfferingSchedule;
        if (!!offering && !!offering.batchId) {
            const result = await confirm(`There is a batch assigned to this schedule, continuing will overwrite the assigned batch. Continue?`, `${this.appInfo.settings.church.toUpperCase()} CHURCH`);
            if (!result) return;
        }
        this.appInfo.pleaseWaitShow();
        const batches = await this.uow.contributionBatches.all('id desc');
        this.appInfo.pleaseWaitHide();
        const modalRef = this.modalService.show(InputDialogComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {

                dialogHeader: 'Graafschap Church',
                dialogPrompt: 'Select Batch for Offering',
                dialogValueArray: batches,
                mode: 'selectWithId',
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
                offering.batchId = result.value;
            }
            await this.uow.commit();
            await this.getData();
            modalRef.hide();
        });
        this.processing = false;
    }

    async delete() {
        if (!this.appointmentData) return;
        const offering = (await this.uow.offeringSchedules.byId(this.appointmentData.id)) as OfferingSchedule;
        if (!!offering && !!offering.batchId) {
            await alert(`There is a batch assigned to this schedule, it CANNOT be deleted.`, `${this.appInfo.settings.church.toUpperCase()} CHURCH`);
            return;
        }
        const result = await confirm(`Are you sure you want to DELETE the selected offering schedule?`, `${this.appInfo.settings.church.toUpperCase()} CHURCH`);
        if (!result) return;
        offering.deleted = new Date();

        await this.uow.commit();
        await this.getData();
    }
}
